import { useNavigate } from "react-router-dom";
import { LockOutlined } from "@ant-design/icons";
import { Row, Col, Card, Button, Result } from "antd";

const ErrorWidget = () => {
  let navigate = useNavigate();
  return (
    <Row gutter={[0, 0]}>
      <Col md={24}>
        <Card align="middle">
          <Result
            status="404"
            title="Oops, looks like something went wrong!"
            subTitle="The requested URL was not found on this server....."
            icon={<LockOutlined />}
            extra={
              <Button type="primary" onClick={() => navigate(-1)}>
                Go Back
              </Button>
            }
          />
        </Card>
      </Col>
    </Row>
  );
};

export default ErrorWidget;
